import type { User } from '@wecasa/common/src/types/commons';
import type { CommonModalProps } from '@wecasa/common/src/types/components';

import { isSpotCleaningSelector } from '@wecasa/customer/src/ducks/basket';
import { getBasketDuration } from '@wecasa/customer/src/ducks/basket-selectors';

import type { MembershipOptIn } from '@wecasa/membership/src/types/membership';

import FullHeightCenteredModal from '@wecasa/web-ui/src/components/modal/full-height-centered-modal';

import { useAppSelector } from '../../../store';
import RecurringContent from './recurring-content';
import SpotContent from './spot-content';

type CleaningMembershipPaywallProps = {
  isOpen: CommonModalProps['isOpen'];
  optInChoice?: MembershipOptIn;
  user?: User;
  closePaywall?: () => void;
  onConfirmPaywall: () => void;
  onOptInChoiceSelection: (newOptInChoice: MembershipOptIn) => void;
};

const CleaningMembershipPaywall = ({
  isOpen,
  optInChoice,
  user,
  onConfirmPaywall,
  closePaywall,
  onOptInChoiceSelection,
}: CleaningMembershipPaywallProps) => {
  const isSpotCleaning = useAppSelector(isSpotCleaningSelector);
  const duration = useAppSelector(getBasketDuration);

  return (
    <FullHeightCenteredModal isOpen={isOpen} onClose={closePaywall}>
      {isSpotCleaning ? (
        <SpotContent
          duration={duration}
          optInChoice={optInChoice}
          user={user}
          onConfirmPaywall={onConfirmPaywall}
          onOptInChoiceSelection={onOptInChoiceSelection}
        />
      ) : (
        <RecurringContent user={user} closePaywall={closePaywall} />
      )}
    </FullHeightCenteredModal>
  );
};

export default CleaningMembershipPaywall;
